import {useLazyQuery} from "@apollo/client";
import classNames from "classnames";
import {useState} from "react";
import {FaTags} from "react-icons/fa";

import {CalculatedBillingDataResponse, GQL_CALCULATE_BILLING_DATA} from "@/lib/queries/billing.ts";
import {AddedValue, BillingPeriod, Plan} from "@/lib/types/billing.ts";
import {QueryError} from "@/lib/types/common.ts";

export interface PromocodeInputProps {
  onChange: (code: string) => void;
  value?: string;
  billingPeriod?: BillingPeriod;
  plan?: Plan;
}

export const PromocodeInput = ({onChange, value = "", billingPeriod, plan}: PromocodeInputProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [error, setError] = useState("");
  const addedItems: AddedValue[] = [];
  const [recalculate] = useLazyQuery<CalculatedBillingDataResponse>(GQL_CALCULATE_BILLING_DATA);
  return isEditing ? (
    <form>
      <div className={classNames("input-group")}>
        <input
          type="text"
          placeholder="Enter promo code..."
          className={classNames("form-control rounded-start-2")}
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
        />
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            setError("");
            recalculate({
              fetchPolicy: "no-cache",
              variables: {
                billingPeriod,
                plan,
                addedItems,
                promoCode: inputValue,
                skipApplicabilityCheck: true,
              },
            }).then(({data}) => {
              const error = (data?.calculateBillingData as QueryError)?.message;
              if (error && error["promo_code"] && error["promo_code"].length > 0) {
                setError(error["promo_code"][0]);
              } else {
                onChange(inputValue || "");
              }
            });
          }}
          className="input-group-text btn btn-primary rounded-end-2"
        >
          Apply
        </button>
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </form>
  ) : (
    <button type="button" className="btn btn-link p-0 text-decoration-none" onClick={() => setIsEditing(true)}>
      {inputValue ? (
        inputValue
      ) : (
        <>
          <FaTags className="me-1" />
          Use Promo Code
        </>
      )}
    </button>
  );
};
